<template>
    <div
        class="w-16 h-16 items-center justify-center"
        :class="hasIcon ? 'flex' : 'hidden sm:flex'"
    >
        <MiscImage
            v-if="hasIcon"
            provider="none"
            :src="item.media.media.url"
            :alt="item.media.media.alt ?? item.title ?? ''"
            :title="item.media.media.title ?? undefined"
            width="48"
            height="48"
            lazy-load
            class="w-12 h-12 object-contain"
        />
    </div>

    <div class="flex flex-col gap-1">
        <h3 class="text-lg font-semibold leading-5 text-link">
            {{ item.title }}
        </h3>

        <p
            v-if="item.subtitle"
            class="text-base leading-5"
        >
            {{ item.subtitle }}
        </p>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { HblBenefitListItem } from '@/utils/types'

const props = defineProps<{
    item: HblBenefitListItem
}>()

const hasIcon = computed(() => Boolean(props.item.media?.media?.url))
</script>
